import React from 'react';
import { DCBSms as DCBSmsScreen } from '@features/dcb-sms';

export const DCBSms = (props: any) => <DCBSmsScreen {...props} />;
